import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

export interface LookupData {
  validate: (string) => boolean;
}

@Component({
  selector: 'app-lookup',
  templateUrl: './lookup.component.html',
  styleUrls: ['./lookup.component.scss']
})
export class LookupComponent implements OnDestroy {

  @Input()
  public data: LookupData;

  @Output()
  public succeed: EventEmitter<string> = new EventEmitter<string>();

  public value: string = null;

  constructor(public modal: BsModalRef) { }

  validate($event) {

    this.value = this.data.validate($event.target.value.toUpperCase()) ? $event.target.value : '';

    if (this.value != null && this.value != '') {
      this.modal.hide();
    }
  }

  ngOnDestroy() {
    if (this.value != null && this.value != '') this.succeed.emit(this.value.toUpperCase());
  }
}
